<div class="main-container blue dark minisidebar" [dir]="dir" [ngClass]="{'minisidebar': minisidebar }">
  <mat-toolbar class="top-bar" [ngClass]="(showDashboard  && showDashBoardOnly) ? 'hide-full-screen' : ''"
    [ngClass]="showUpperHeader ? '' : (showDashboard && showDashBoardOnly) ? 'hide-full-screen' : 'hide-top-bar'">
    <span fxFlex></span>
    <app-header [isAdminView]="isAdminView" [exitFullScreen]="exitFullScreen" [allFeaturesNames]="allFeaturesNames"
    (selectedDashboard)="getSelectedDashboard($event)" (onAlarmsToggle)="onAlarmsToggle()" (upperHeader)="upperHeader($event)" style="width: 100%;"></app-header>
  </mat-toolbar>

  <mat-drawer-container hasBackdrop="false" [ngClass]="!showDashboard ? 'normalScreen': 'fullScreen'">
    <mat-drawer #drawer mode="over" position="end" disableClose="true" class="customDrawer"
      [ngClass]="drawerService.drawerClass$ | async">
      <ng-template [cdkPortalOutlet]="selectedPortal"></ng-template>
    </mat-drawer>

    <mat-drawer-content>
      <mat-sidenav-container [ngClass]="( isShowing && !showDashBoardOnly ) ? 'dropdown-state' : 'hidenav' "
        class="example-sidenav-container black" [style.marginTop.px]="mobileQuery.matches ? 0 : 0"
        [ngClass]="{'minisidebar': minisidebar}">
        <mat-sidenav #snav id="snav" class="pl-xs left-sidebar" [ngClass]="!iconWithText ? 'mat-drawer-icon' : '' "
          [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0" [opened]="mobileQuery.matches"
          [disableClose]="mobileQuery.matches" (open)="sidebarOpened = true" (close)="sidebarOpened = false"
          [ngClass]="{'dashboard-sidebar': !isAdminView}"
          [ngClass]="{'dashboard-sidebar': !isAdminView, 'dashboard-left-menu': isDashboardPage}">
          <app-sidebar *ngIf="isAdminView && isShowing" class="app-sidebar"></app-sidebar>
          <app-dashboard-sidebar *ngIf="!isAdminView" [selectedBreadCrumb]="selectedBreadCrumb"
            (selectedNodePath)="buildBreadCrumbs($event)"></app-dashboard-sidebar>
        </mat-sidenav>

        <mat-sidenav-content class="page-wrapper" id="p-wrapper"
          [ngStyle]="{background: (isDashboardPage || isUserAlarmsPage) ? isLightMode ? '#F4F5F5' : '#101217' : ''}">
          <div [ngClass]="{'page-content': !isDashboardPage, 'page-content-dashboard': isDashboardPage }">
            <section *ngIf="isDashboardPage" fxLayout="row" fxLayoutAlign="space-between center">
              <span fxLayout="row" fxLayoutAlign="start center">
                <p-breadcrumb (onItemClick)="onBreadCrumbItemClick($event.item)" [model]="breadCrumbItems"></p-breadcrumb>
                <span [ngClass]="{'forward-icon': selectedDashboardName }"></span>
                <mat-icon *ngIf="selectedDashboardName" class="selected-breadcrumb-icon">dashboard</mat-icon>
                <span class="selected-breadcrumb-name"> {{selectedDashboardName}} </span>
              </span>
              <span class="asset-status-section">
                <span [ngStyle]="{'color': (selectedAssetLiveStatus === 'ONLINE') ? '#46b546' : '#d44d4d' }"> {{
                  selectedGroupName ? '' : selectedAssetLiveStatus }} </span>
                <span class="asset-live-timestamp"> {{ selectedGroupName ? '' : selectedAssetTimeStamp | date:
                  'dd/M/yyyy hh:mm:ss a' }} </span>
              </span>
            </section>
            <router-outlet>
              <app-spinner></app-spinner>
            </router-outlet>
          </div>

        </mat-sidenav-content>
      </mat-sidenav-container>
    </mat-drawer-content>
  </mat-drawer-container>
</div>